export class JobDictionary {
    id: string;
    code: string;
    name: string;
    description: string;
    isActive: boolean;
    isHrisManaged: boolean;
    dateCreated: string;
    createdByUserId: string;
}
